import { Text } from 'common-components'
import { memo, useState } from 'react'
import LangWithBorderIcon from 'assets/svgr-icons/LangWithBorder.svg'

import { ITtsLanguageOption } from 'types/text-to-speech'
import AdvancedTooltip from 'common-components/AdvancedTooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { emptyFunction } from 'utils'
import * as Styled from './styled'
import { ITtsLanguageItemProps } from './types'

const MULTILINGUAL_LANGUAGE_ID = 'multi'

interface ITooltipConfig {
  showTooltip: boolean
  tooltipText: string
}
const getTooltipConfig = (
  item: ITtsLanguageOption | null,
  isHeader: boolean
): ITooltipConfig => {
  const isMultilingual = item?.id === MULTILINGUAL_LANGUAGE_ID
  const showTooltip = isHeader || isMultilingual
  const tooltipText = isHeader
    ? translate(T.LANGUAGE_LABEL)
    : translate(T.MULTILINGUAL_LANGUAGE_TOOLTIP)

  return { showTooltip, tooltipText }
}

const TtsLanguageItem: React.FC<ITtsLanguageItemProps> = props => {
  const {
    item,
    isActive = false,
    isHeader = false,
    onClick = emptyFunction,
    className
  } = props

  const { country, countryName, langName } = item || {
    country: '',
    countryName: '',
    langName: translate(T.LANGUAGE_LABEL)
  }

  const { showTooltip, tooltipText } = getTooltipConfig(item, isHeader)

  const [languageItemRef, setLanguageItemRef] = useState<HTMLDivElement | null>(
    null
  )

  const isMultilingual = item?.id === MULTILINGUAL_LANGUAGE_ID

  return (
    <Styled.TtsLanguageItemWrapper
      ref={setLanguageItemRef}
      className={className}
      onClick={onClick}
      $isActive={isActive}
      $isHeader={isHeader}
    >
      {(country || isMultilingual) && (
        <Styled.LanguageItemCode $isActive={isActive}>
          {isMultilingual ? <LangWithBorderIcon /> : country}
        </Styled.LanguageItemCode>
      )}
      <Styled.InfoWrapper>
        {langName && (
          <Text
            color={isActive ? 'secondaryDark' : 'secondarySemiDark'}
            type="h2"
            lineHeight="17px"
          >
            {langName}
          </Text>
        )}
        {countryName && !isHeader && (
          <Text color="secondary" type="p" lineHeight="12px">
            {countryName}
          </Text>
        )}
        {showTooltip && (
          <AdvancedTooltip
            tooltipText={tooltipText}
            tooltipPosition="top"
            btnRef={{ current: languageItemRef }}
          />
        )}
      </Styled.InfoWrapper>
    </Styled.TtsLanguageItemWrapper>
  )
}

export default memo(TtsLanguageItem)
